///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. Api
        a. returnToDisplayCase
        b. getHoleScoreClass
    
    2. Property Accessors
        a. getData
        b. setData
*/

(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3UltimateScorecardData', {
            templateUrl: 'app/home/ultimate-scorecard/ultimate-scorecard-data.component.html',
            controller: UltimateScorecardDataComponent,
            bindings: { model: '<' }
        });

    var isNumber = angular.isNumber;

    UltimateScorecardDataComponent.$inject = ['$scope', 'defaultCourseLogoUrl'];
    function UltimateScorecardDataComponent($scope, defaultCourseLogoUrl) {
        // Variables
        var ctrl = this;

        // Properties
        Object.defineProperty(ctrl, 'data', { get: getData, set: setData });
        ctrl.defaultCourseLogo = defaultCourseLogoUrl;

        // Methods
        ctrl.returnToDisplayCase = returnToDisplayCase;
        ctrl.getHoleScoreClass = getHoleScoreClass;

        /////////////////////////////

        // Api
        function returnToDisplayCase() {
            ctrl.data = null;
        }
        function getHoleScoreClass(holeScore) {
            var diff = isNumber(holeScore.esc) && isNumber(holeScore.par) ? holeScore.esc - holeScore.par : null,
                isTot = holeScore.number % 1 != 0;

            return isTot ? null : diff > 1 ? 'double-bogey' : diff === 1 ? 'bogey' : diff === 0 ? 'par' : diff === -1 ? 'birdie' : diff < -1 ? 'eagle' : null;
        }

        // Property Accessors
        function getData() {
            return ctrl.model.scorecard;
        }
        function setData(value) {
            ctrl.model.scorecard = value;
        }
    }
})();